import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const MessageView = () => {
  const { reportId } = useParams();

  return (
    <div className="pt-16 pb-6 px-4 sm:px-6 max-w-5xl mx-auto min-h-screen flex flex-col">
      {/* Header */}
      <div className="flex items-center mb-4">
        <Link to="/" className="text-slate-500 hover:text-slate-700 mr-3">
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <h1 className="text-xl font-semibold text-slate-800">
          Notification Details
        </h1>
      </div>
      
      <div className="flex-1 bg-white rounded-lg shadow p-6">
        <p className="text-lg font-medium mb-4">Report ID: {reportId}</p>
        
        <div className="bg-blue-50 p-4 rounded-lg mb-6">
          <p className="text-sm text-blue-800">
            This is a placeholder for the notification details page. In a real implementation, 
            this would show the full notification content and related information.
          </p>
        </div>
        
        <div className="flex justify-end">
          <button 
            onClick={() => window.history.back()}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageView; 